
import {
    Prop,
    Component,
    Vue,
    PropSync,
    InjectReactive,
    Watch
} from 'vue-property-decorator'

import RichText from "@/components/rich-text.vue";

import { cloneDeep } from 'lodash';

import { saveOrUpdatePresCategory, getCategoryDetail } from "@/api/prescriptionDb";


@Component({ name: 'prescriptionProduct-components-productDetail',
    components: {
        RichText,
    }
})
export default class ProductDetail extends Vue {
    @PropSync("visible", { default: false }) dialogVisible !: boolean;
    @Prop() productInfo !: any;

    @InjectReactive()
    merchantId !:number;

    productFormData = {} as any;

    loadingDetail = false;

    dialogClose() {
        this.dialogVisible = false;
        this.productFormData = {};
    }

    dialogConfirm() {
        const params = cloneDeep(this.productFormData);
        Object.assign(params, { merchantId: this.merchantId, ownerType: this.merchantId ? 1: 0 })
        // this.btnLoading = true;
        saveOrUpdatePresCategory(params).then((res) => {
          this.dialogClose();
        })
    }

    @Watch("dialogVisible")
    getCategoryDetail() {
        if (!this.dialogVisible) return;
        this.loadingDetail = true;
        getCategoryDetail(this.productInfo.id).then((res) => {
            this.productFormData = { ...res.data, id: this.productInfo.id, productRemark: res.data?.productRemark };
        }).finally(() => {
            this.loadingDetail = false;
        })
    }
}
